import { Box, EnhancedDimension, Skeleton, Text } from '@factorialco/deprecated-design-system'
import {
  FinanceValueObjectsFinancialDocumentTypeEnum,
  FinancialDocumentForSelectFragment,
  FinancialDocumentSelectorDocument,
} from 'generated/resources/graphql'

import { EntitySelector } from 'modules/core/components/EntitySelector'
import i18n from 'modules/core/lib/i18n'

const FinancialDocumentItem = ({
  financialDocument,
}: {
  financialDocument: FinancialDocumentForSelectFragment
}) => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center" key={financialDocument.id}>
      <Text.Normal size="300">{financialDocument.documentNumber}</Text.Normal>
    </Box>
  )
}

const FinancialDocumentSkeleton = () => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center">
      <Skeleton width="s240" height="s32" />
    </Box>
  )
}

interface Props {
  companyId: number
  vendorId?: number
  toDate?: string
  documentTypes?: FinanceValueObjectsFinancialDocumentTypeEnum[] | null
  error?: string
  mandatory?: boolean
  disabled?: boolean
  width?: EnhancedDimension
  minWidth?: EnhancedDimension
  label?: string
  description?: string
  emptyLabel?: string
  scopedFinancialDocumentsIds?: number[]
  value?: FinancialDocumentForSelectFragment | null
  onSelect: (financialDocument: FinancialDocumentForSelectFragment | null) => void
}

export const FinancialDocumentSelector = (props: Props) => {
  const {
    companyId,
    vendorId,
    toDate,
    documentTypes,
    error,
    mandatory,
    label,
    description,
    width,
    minWidth,
    emptyLabel,
    disabled = false,
    scopedFinancialDocumentsIds,
  } = props

  const renderEntity = (entity: FinancialDocumentForSelectFragment) => (
    <FinancialDocumentItem financialDocument={entity} />
  )

  const renderSkeleton = () => <FinancialDocumentSkeleton />

  const variables = {
    companyId: companyId,
    ...(scopedFinancialDocumentsIds && { ids: scopedFinancialDocumentsIds }),
    ...(documentTypes && { documentTypes: documentTypes }),
    ...(vendorId && { vendorId: vendorId }),
    ...(toDate && { toDate: toDate }),
  }

  const filterEntities = (entities: FinancialDocumentForSelectFragment[]) => {
    return entities
  }

  return (
    <EntitySelector
      label={label}
      description={description}
      disabled={disabled}
      error={error}
      mandatory={mandatory}
      document={FinancialDocumentSelectorDocument}
      variables={variables}
      width={width}
      minWidth={minWidth}
      extractConnection={(data) => data.finance.financialDocumentsConnection}
      renderEntity={renderEntity}
      value={props.value ?? null}
      onChange={props.onSelect}
      renderSkeleton={renderSkeleton}
      renderValue={(entity) => (
        <Text.Normal>
          {entity !== null
            ? entity.documentNumber
            : emptyLabel ?? i18n.t('finance.invoices.detail.fields.original_invoice')}
        </Text.Normal>
      )}
      filterEntities={filterEntities}
    />
  )
}
